import { BackButton } from '@/shared/ui';
import type { BackButtonProps } from '@/shared/ui/back-button';

export type PageHeaderProps = {
	title?: string;
	showBorder?: boolean;
} & (PageHeaderWithBackButtonProps | PageHeaderWithoutBackButtonProps);

type PageHeaderWithBackButtonProps = {
	showBackButton: true;
} & BackButtonProps;

type PageHeaderWithoutBackButtonProps = {
	showBackButton?: false;
};

/**
 * 공통 페이지 헤더 컴포넌트
 *
 * @example
 * // 1. 타이틀만 + 하단 보더
 * <PageHeader title="마이페이지" showBorder />
 *
 * // 2. 뒤로가기 + 타이틀 (우측 빈 영역 자동 생성)
 * <PageHeader title="검색" showBackButton />
 *
 * // 3. 뒤로가기 + 타이틀 + 하단 보더
 * <PageHeader title="상세" showBackButton showBorder />
 *
 * // 4. 뒤로가기만
 * <PageHeader showBackButton />
 */

const PageHeader = ({
	title,
	showBackButton = false,
	showBorder = false,
	...backButtonProps
}: PageHeaderProps) => {
	const showRightSlot = !!showBackButton && !!title;
	const borderClass = showBorder ? 'border-b border-mantang-gray-100' : '';

	return (
		<header className={`flex h-12.5 shrink-0 items-center px-4 ${borderClass}`}>
			{showBackButton && <BackButton {...backButtonProps} />}
			{title && (
				<span className="flex-1 text-center font-medium text-[15px] text-mantang-black">
					{title}
				</span>
			)}
			{showRightSlot && <div className="size-6 shrink-0" />}
		</header>
	);
};

export default PageHeader;
